import { Box, Typography, LinearProgress } from '@mui/material';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import ApartmentIcon from '@mui/icons-material/Apartment';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { styles } from './styles';


const StatusRow = ({ label, msHired, departmental }) => (
    <Box sx={styles.statusRowCard}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
            {/* Label */}
            <Typography sx={{ fontSize: 15, fontWeight: 800, letterSpacing: 1, color: '#8a95a3', minWidth: 120, }}>
                {label.toUpperCase()}
            </Typography>

            {/* Bars section */}
            <Box sx={{ flex: 1 }}>
                {/* MS-Hired */}
                <Box sx={{ display: 'grid', gridTemplateColumns: '110px 1fr 90px', alignItems: 'center', gap: 1.5, mb: 1 }}>
                    <Typography sx={{ fontSize: 16, color: '#5a6a7a', fontWeight: 500 }}>MS-Hired</Typography>
                    <LinearProgress
                        variant="determinate"
                        value={(msHired.active / msHired.total) * 100}
                        sx={{ ...styles.progressBlue, height: 10, borderRadius: 4 }}
                    />
                    <Typography sx={{ fontSize: 16, color: '#1a90ff', fontWeight: 700, textAlign: 'right' }}>
                        {msHired.active}<span style={{ color: '#aab4c0', fontWeight: 400 }}>/{msHired.total}</span>
                    </Typography>
                </Box>

                {/* Departmental */}
                <Box sx={{ display: 'grid', gridTemplateColumns: '110px 1fr 90px', alignItems: 'center', gap: 1.5 }}>
                    <Typography sx={{ fontSize: 16, color: '#5a6a7a', fontWeight: 500 }}>Departmental</Typography>
                    <LinearProgress
                        variant="determinate"
                        value={(departmental.active / departmental.total) * 100}
                        sx={{ ...styles.progressPurple, height: 10, borderRadius: 4 }}
                    />
                    <Typography sx={{ fontSize: 16, color: '#a855f7', fontWeight: 700, textAlign: 'right' }}>
                        {departmental.active}<span style={{ color: '#aab4c0', fontWeight: 400 }}>/{departmental.total}</span>
                    </Typography>
                </Box>
            </Box>
        </Box>
    </Box>
);

const VehicleStatusPanel = ({ data }) => {
    const fleetTotal = data?.msHiredTotal + data?.departmentalTotal;

    const rows = [
        { label: 'Today', msHired: { active: data?.msHiredActiveToday, total: data?.msHiredTotal }, departmental: { active: data?.departmentalActiveToday, total: data?.departmentalTotal } },
        { label: 'Yesterday', msHired: { active: data?.msHiredActiveYesterday, total: data?.msHiredTotal }, departmental: { active: data?.departmentalActiveYesterday, total: data?.departmentalTotal } },
        { label: 'Monthly', msHired: { active: data?.msHiredActiveMonthly, total: data?.msHiredTotal }, departmental: { active: data?.departmentalActiveMonthly, total: data?.departmentalTotal } },
    ];
    return (

        <Box sx={styles.sectionCard}>
            {/* Header */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <DirectionsBusIcon sx={{ color: '#1a90ff', fontSize: 35 }} />
                    <Box>
                        <Typography sx={styles.sectionTitle}>Vehicle Status</Typography>
                        <Typography sx={styles.sectionSubtitle}>Fleet Overview &amp; Activity</Typography>
                    </Box>
                </Box>
                <Box sx={{ textAlign: 'right' }}>
                    <Typography sx={{ fontSize: 11, color: '#8a95a3', fontWeight: 600 }}>TOTAL FLEET</Typography>
                    <Typography sx={{ fontSize: 32, fontWeight: 900, color: '#1a2d45', lineHeight: 1 }}>
                        {fleetTotal ? fleetTotal.toLocaleString() : "-"}
                    </Typography>
                </Box>
            </Box>

            {/* MS-Hired + Departmental tiles */}
            <Box sx={{ display: 'flex', gap: 2, mb: 0 }}>
                <Box sx={{ ...styles.msHiredTile, cursor: 'pointer' }}
                    onClick={() => window.open('/vehiclelist?type=MS_HIRED&isWorkOrderVehicle=true', '_blank')}>
                    <Typography sx={styles.tileLabel}>MS-HIRED</Typography>

                    <Typography sx={styles.tileCount}>{data?.msHiredTotal?.toLocaleString()}</Typography>

                    <Typography sx={styles.tileSubtext}>vehicles (as per work order)</Typography>
                </Box>
                <Box sx={{ ...styles.departmentalTile, cursor: 'pointer' }}  onClick={() => window.open('/vehiclelist?type=DEPARTMENTAL', '_blank')}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                        <ApartmentIcon sx={{ fontSize: 14, opacity: 0.85 }} />
                        <Typography sx={styles.tileLabel}>DEPARTMENTAL</Typography>
                    </Box>
                    <Typography sx={styles.tileCount}>{data?.departmentalTotal?.toLocaleString()}</Typography>
                    <Typography sx={styles.tileSubtext}>vehicles in service</Typography>
                </Box>
            </Box>

            {/* Active badge */}
            <Box sx={styles.activeBadge}>
                <CheckCircleOutlineIcon sx={{ fontSize: 18, color: '#22c55e' }} />
                <Typography sx={{ fontSize: 16, fontWeight: 600, color: '#22c55e' }}>
                    {data?.activeToday} vehicles active today
                </Typography>
            </Box>

            {/* Status rows */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 1 }}>
                {rows && rows.map((row) => (
                    <StatusRow key={row.label} {...row} />
                ))}
            </Box>
        </Box>
    )
};
export default VehicleStatusPanel